// ----------------------------------------------------------------------------
// Component: Featured Product
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

// Scripts
import Swiper, { Navigation, Pagination, Scrollbar, A11y, Keyboard } from 'swiper';
import 'snippets/background-media/background-media';
import 'snippets/reviews/reviews';

// Styles
import './_featured-product.scss';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import 'swiper/css/a11y';
import 'swiper/css/keyboard';

// -------------------------------------
// Variables
// -------------------------------------
const CAROUSEL_SELECTOR = '.carousel--featured-product';
const CAROUSEL_CLASS = 'carousel--featured-product';
const CAROUSEL_SECTION_SELECTOR = '.featured-product';
const CAROUSEL_SECTION_CLASS = 'featured-product';
// const CAROUSEL_PREV_BUTTON_SELECTOR = '.swiper-button-prev';
// const CAROUSEL_NEXT_BUTTON_SELECTOR = '.swiper-button-next';


// -------------------------------------
// Hooks
// -------------------------------------
document.querySelectorAll(CAROUSEL_SECTION_SELECTOR)
        .forEach((element, index) => {
            
            // Generate unique class for each collection list slider
            element.querySelector(CAROUSEL_SELECTOR).classList.add(`${CAROUSEL_CLASS}-${index}`);

            // Generate unique btn classes for slider arrows
            // element.querySelector(CAROUSEL_PREV_BUTTON_SELECTOR).classList.add(`${CAROUSEL_SECTION_CLASS}-btn-prev-${index}`);
            // element.querySelector(CAROUSEL_NEXT_BUTTON_SELECTOR).classList.add(`${CAROUSEL_SECTION_CLASS}-btn-next-${index}`);

            const swiper = new Swiper(`.${CAROUSEL_CLASS}-${index}`, {
                // Optional parameters
                modules: [Navigation, Pagination, Scrollbar, A11y, Keyboard],
                slidesPerView: 1,
                spaceBetween: 15,
                observer: true,
                observeParents: true,
                navigation: true,
                a11y: false,
                watchOverflow: true, // Do not turn into sliders if number of slides is less than slidesPerView.
                pagination: {
                    el: ".swiper-pagination",
                    clickable: true
                },
                breakpoints: {
                    // when window width is >= 680px
                    1024: {
                        slidesPerView: 100,
                        watchOverflow: true,
                        pagination: false
                    }
                }
            });
    
            swiper.slides.forEach(function(slide, index) {
                const slideLink = slide.querySelector('a');
                slideLink.addEventListener('focus', function(e) {
                    swiper.slideTo(index);
                })
            });
        })